import * as preact from "preact"
import { ButtonVariantProps, buttonVariants } from "./buttonVariants"
import clsx from "clsx"
import { FunctionComponent } from "preact"
import { JSX } from "preact/jsx-runtime"

type IconDirection = "left" | "right"

type BaseButtonProps = ButtonVariantProps & {
  icon?: {
    node: preact.ComponentChildren
    direction?: IconDirection
  }
  children?: preact.ComponentChildren
  href?: string
  disabled?: boolean

} & JSX.HTMLAttributes<HTMLButtonElement>

type ButtonProps = BaseButtonProps & JSX.ButtonHTMLAttributes<HTMLButtonElement>

type LinkProps = BaseButtonProps & JSX.AnchorHTMLAttributes<HTMLAnchorElement>

type UnifiedButtonProps = (ButtonProps & { href?: never }) | (LinkProps & { href: string })

const Button: FunctionComponent<UnifiedButtonProps> = ({
  children,
  size = "medium",
  variant = "primary",
  fullWidth = false,
  icon,
  disabled = false,
  href,
  ...props
}) => {
  const className = clsx(buttonVariants({ size, variant, fullWidth }))

  const content = (
    <div
      className={clsx("flex items-center gap-x-2 flex-nowrap text-nowrap", {
        "flex-row": icon?.direction !== "right",
        "flex-row-reverse": icon?.direction === "right",
      })}
    >
      {icon && <span className="inline-block">{icon.node}</span>}
      {children}
    </div>
  )

  if (href && !disabled) { // If  disabled, we don't want to render as a link to be able to reuse the button styles
    return (
      <a
        {...(props as LinkProps)}
        href={href}
        className={className}
      >
        {content}
      </a>
    )
  }

  return (
    <button
      {...(props as ButtonProps)}
      className={className}
      disabled={disabled}
    >
      {content}
    </button>
  )
}

export default Button
